import CustomBarChart from "./CustomBarChart";
import CustomLineChart from "./CustomLineChart";
import CustomPieChart from "./CustomPieChart";
import styles from "../../RHSWidgetModal.module.scss";

interface AssessmentContentType {
  title: string;
  subTitle: string;
  chartType: string;
}

const pieData = [
  { name: 'Inflation', value: 400, color: '#444CE7' },
  { name: 'Geopolitics', value: 300, color: '#6172F3' },
  { name: 'Ukraine War', value: 300, color: '#8098F9' },
  { name: 'Covid Lockdows', value: 200, color: '#A4BCFD' },
  { name: 'Sanctions', value: 278, color: '#C7D7FE' },
];

const AssessmentContent = ({ title, subTitle, chartType }: AssessmentContentType) => {
  const renderLegend = () => {
    return (
      <ul>
        {
          pieData.map((entry, index: number) => (
            <li key={`item-${index}`} style={{ color: entry.color }}>
              <div className="row">
                <div className="col text-white">
                  {entry.name}
                </div>
                <div className="col">
                  <span className="text-gray-400">39.11%</span>
                  <span className="text-info">(+2.98%)</span>
                </div>
              </div>

            </li>
          ))
        }
      </ul>
    );
  };

  const renderSwitch = () => {
    switch (chartType) {
      case "line":
        return <CustomLineChart />;
      case "bar":
        return <CustomBarChart />
      case "pie":
        return (
          <div className="row justify-content-between">
            <div className="col-6">
              <CustomPieChart data={pieData} />
            </div>
            <div className="col-6 m-auto">
              {renderLegend()}
            </div>
          </div>
        );
      default:
        return "line";
    }
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h5>{title}</h5>
          <p className={styles.description}>{subTitle}</p>
        </div>
        <button className="btn btn-flat text-white flex-center">
          <i className="icon-more-vertical text-5c ml-2"></i>
        </button>
      </div>
      <div className="mv-5">
        {renderSwitch()}
      </div>
    </>
  );
}

export default function Assessment() {
  return (
    <div className="pv-3">
      <AssessmentContent title="Risk trend" subTitle="Compared to 12% last year" chartType="line" />
      <AssessmentContent title="Impact analysis" subTitle="We predict a large impact over the next 36 months in the following areas." chartType="bar" />
      <AssessmentContent title="Key drivers" subTitle="Inflation, geopolitics, and Covid lockdowns are driving this risk." chartType="pie" />
    </div>
  );
}
